;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.ChangePassword = Backbone.Model.extend({

		constructor: function(){
			this.validations = new Model.Validations();
			this.setSchemaValidation();
			Backbone.Model.apply(this, arguments);
		},

		extendSchema() {
			return this;
		},

		initialize() {
			this.extendSchema();
		},

		setSchemaValidation: function(){
			this.schema = _.mapObject(this.schema, _.bind(function(value ,key){
				value.validators = this.validations.getValidationItems( value.validators ).length ? this.validations.getValidationItems( value.validators ): value.validators;
				return value;
			}, this));
		},

		url: 'password_recovery/change_password',
		defaults: {
			"token": "",
			"password": "",
			"passwordConfirm": ""
		},
		schema: {
			password:{
				type: 'Password',
				title: "Password*",
				editorClass: 'password input-text',
				editorAttrs: {
					minlength: 8,
					placeholder: 'Password:'
				},
				validators:  ['password_required','password_regexp']
			},
			passwordConfirm:{
				type: 'Password',
				title: "Confirm Password*",
				editorClass: 'passwordConfirm input-text',
				editorAttrs: {
					placeholder: 'Confirm Password:'
				},
				validators:  ['passwordConfirm_required','passwordConfirm_regexp', 'password_match']
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));